import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Toaster, toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_BASEURL;

function HookMessageConfig() {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isEnabled: false,
            maxMessagesSent: 0,
            timeWindowMinutes: 0,
            maxCharLimit: 0,
            allowEmojis: false,
            maxMessagesSaved: 0
        }
    });

    const [loading, setLoading] = useState(false);

    const fetchConfig = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            const res = await axios.get(`${BASE_URL}/admin/hookMessageConfig`, {
                headers: {
                    Authorization: token,
                },
            });

            const data = res?.data?.data?.value;

            if (data) {
                setValue("isEnabled", data.isEnabled || false);
                setValue("maxMessagesSent", data.maxMessagesSent || 0);
                setValue("timeWindowMinutes", data.timeWindowMinutes || 0);
                setValue("maxCharLimit", data.maxCharLimit || 0);
                setValue("allowEmojis", data.allowEmojis || false);
                setValue("maxMessagesSaved", data.maxMessagesSaved || 0);
            }
        } catch (err) {
            console.error("Failed to load hook message config", err);
            toast.error("Failed to load configuration");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConfig();
    }, []);

    const onSubmit = async (formData) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            const payload = {
                isEnabled: Boolean(formData.isEnabled),
                maxMessagesSent: Number(formData.maxMessagesSent),
                timeWindowMinutes: Number(formData.timeWindowMinutes),
                maxCharLimit: Number(formData.maxCharLimit),
                allowEmojis: Boolean(formData.allowEmojis),
                maxMessagesSaved: Number(formData.maxMessagesSaved)
            };

            const res = await axios.patch(
                `${BASE_URL}/admin/hookMessageConfig`,
                payload,
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res?.data?.success || res?.status === 200 || res?.status === 201) {
                toast.success("Configuration updated successfully");
            } else {
                toast.error("Update failed");
            }
        } catch (err) {
            console.error("Error updating config", err);
            toast.error("Something went wrong while updating");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid">
            <Toaster position="top-right" />
            <div className="row g-3 mb-3 align-items-center">
                <div className="col">
                    <h1 className="h3 mt-2">Hook Message Configuration</h1>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row g-3">
                                    <div className="col-md-6 d-flex align-items-center mt-4">
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isEnabled"
                                                {...register("isEnabled")}
                                            />
                                            <label className="form-check-label ms-2" htmlFor="isEnabled">
                                                Enable Hook Messages
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6 d-flex align-items-center mt-4">
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="allowEmojis"
                                                {...register("allowEmojis")}
                                            />
                                            <label className="form-check-label ms-2" htmlFor="allowEmojis">
                                                Allow Emojis
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Max Messages Sent</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            {...register("maxMessagesSent", {
                                                required: "This field is required",
                                                min: { value: 0, message: "Must be 0 or greater" }
                                            })}
                                        />
                                        {errors.maxMessagesSent && (
                                            <span className="text-danger">{errors.maxMessagesSent.message}</span>
                                        )}
                                    </div>

                                    {/* <div className="col-md-6">
                                        <label className="form-label">Time Window (Minutes)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            {...register("timeWindowMinutes", {
                                                required: "This field is required",
                                                min: { value: 0, message: "Must be 0 or greater" }
                                            })}
                                        />
                                        {errors.timeWindowMinutes && (
                                            <span className="text-danger">{errors.timeWindowMinutes.message}</span>
                                        )}
                                    </div> */}

                                    <div className="col-md-6">
                                        <label className="form-label">Max Character Limit</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            {...register("maxCharLimit", {
                                                required: "This field is required",
                                                min: { value: 0, message: "Must be 0 or greater" }
                                            })}
                                        />
                                        {errors.maxCharLimit && (
                                            <span className="text-danger">{errors.maxCharLimit.message}</span>
                                        )}
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Max Messages Saved</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            {...register("maxMessagesSaved", {
                                                required: "This field is required",
                                                min: { value: 0, message: "Must be 0 or greater" }
                                            })}
                                        />
                                        {errors.maxMessagesSaved && (
                                            <span className="text-danger">{errors.maxMessagesSaved.message}</span>
                                        )}
                                    </div>

                                    <div className="col-sm-12 mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Updating..." : "Save Configuration"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HookMessageConfig;
